import React, { useContext, useState } from "react";

import { Grid } from "@mui/material";
import "./YouTubeVideosStyle.css";

import { t } from "i18next";
import { Context } from "../LocalWrapper";

const videoData = [
  { id: "90w2DDe-kqs", title: "GPS Reports Vehicles Idle Time Summary" },
  { id: "KonoHFTDr8E", title: "GPS Reports Vehicle Daily Usage Report" },
  { id: "OYH18ecKkXE", title: "GPS Reports Speed Violations" },
  { id: "2TYwEizGSVM", title: "GPS Reports Parking Time Report" },

  { id: "LXJPI8o0sm4", title: "Control Panel Operations" },
  { id: "-KnGcNDcBr4", title: "landmarks" },
  { id: "HknYiJ_7LRQ", title: "preventive maintenance" },
  { id: "23MEjdSeXzg", title: "operations WO" },

  // Add all 31 video IDs and titles
];

const YouTubeVideos = () => {
  const context = useContext(Context);

  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <div className="youtube-container" dir={context.dir}>
      <h2 className="oz-title">{t("fms_videos_header")}</h2>
      <Grid container spacing={1}>
        {videoData.map((video, index) => (
          <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
            <div className="video-grid">
              <VideoCard
                key={video.id}
                video={video}
                onSelect={() => setSelectedVideo(video)}
              />
            </div>
          </Grid>
        ))}
      </Grid>
      <h4 className="oz-paragraph">
        {t("fms_videos_more")} {"  "}
        <a
          href="https://www.youtube.com/@etitfms7760/videos"
          style={{ textDecoration: "underline", color: "var(--primary)" }}
        >
          youtube
        </a>{" "}
        {/* ... */}
      </h4>
      {selectedVideo && (
        <VideoModal
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}
    </div>
  );
};

const VideoCard = ({ video, onSelect }) => (
  <div className="video-card" onClick={onSelect}>
    <img
      src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
      alt={video.title}
    />
    <h3>{video.title}</h3>
  </div>
);

const VideoModal = ({ video, onClose }) => (
  <div className="video-modal">
    <div className="video-modal-content">
      <button className="close-btn" onClick={onClose}>
        ×
      </button>
      <iframe
        src={`https://www.youtube.com/embed/${video.id}`}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={video.title}
      ></iframe>
    </div>
  </div>
);

export default YouTubeVideos;
